
import { Users, Crown, Sparkles } from "lucide-react";

const subscriptionIcons = {
  essentials: Users,
  pro: Crown,
  elite: Sparkles,
} as const;

interface WelcomeHeaderProps {
  userName: string;
  subscriptionTier?: "essentials" | "pro" | "elite";
}

export default function WelcomeHeader({ userName, subscriptionTier = "essentials" }: WelcomeHeaderProps) {
  const SubscriptionIcon = subscriptionIcons[subscriptionTier];

  return (
    <div className="flex flex-col space-y-2">
      <h1 className="text-3xl font-bold">
        Welcome back, {userName}! 👋
      </h1>
      <div className="flex items-center gap-2 text-muted-foreground">
        <SubscriptionIcon className="h-5 w-5" />
        <span className="capitalize">{subscriptionTier} Plan</span>
      </div>
    </div>
  );
}
